var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.mapBlock},[_c('div',{ref:"container",class:_vm.$style.container}),(_vm.centerMarker)?_c('div',{class:[_vm.$style.marker, ( _obj = {}, _obj[_vm.$style.raised] = _vm.markerRaised, _obj )]},[_c('div',{class:_vm.$style.body}),_c('div',{class:_vm.$style.shadow})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }